<template>
  <div>
    <Header page="company"/>
    <b-container>
      <Breadcrumb />
      <b-row>
        <b-col cols="3">
          <SidebarVendor/>
        </b-col>
        <b-col cols="8">
          <form>
            <label for="" class="admin-vendor-label">会社名<span class="required">*</span></label>
            <input type="text" name="" id="" class="input-form" placeholder="会社名を入力してください" v-model="company_name">
            <b-row>
              <b-col cols="6">
                <label for="" class="admin-vendor-label">代表者名<span class="required">*</span></label>
                <input type="text" name="" id="" class="input-form" placeholder="代表者名を入力してください" v-model="representative_name">
              </b-col>
              <b-col cols="6">
                <label for="" class="admin-vendor-label">代表電話番号<span class="required">*</span></label>
                <input type="text" name="" id="" class="input-form" placeholder="代表電話番号を入力してください" v-model="representative_phone">
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <label for="" class="admin-vendor-label">メールアドレス<span class="required">*</span></label>
                <input type="text" name="" id="" class="input-form" placeholder="メールアドレスを入力してください" v-model="representative_email">
              </b-col>
              <b-col cols="12" lg="6">
                <div class="filter-wrapper">
                  <b-form inline class="float-md-left mt-4">
                    <b-form-checkbox
                      stacked
                      class="ml-2"
                      v-model="parent_company"
                      :value="1"
                      :unchecked-value="0"
                    > 登録代表会社</b-form-checkbox>
                  </b-form>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="!parent_company" class="mt-3">
              <b-col cols="12" lg="6">
                <div class="form-group">
                <label class="label-form">会社</label>
                <div class="input-group">
                  <b-form-select  class="select select-dropdown input-form" v-model="company_uuid">
                    <b-form-select-option v-for="company in companies" :key="company.id" :value="company.id">{{company.company_name}}</b-form-select-option>
                  </b-form-select>
                </div>
              </div>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-center admin-vendor-btnGroup">
              <button class="btn btn-secondary btn-rounder mr-30" type="button" @click="goback">キャンセル</button>
              <button class="btn btn-primary btn-rounder" type="button" @click="addCompany">保存</button>
            </div>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from '@/components/share/Header.vue'
import Breadcrumb from '@/components/share/Breadcrumb.vue'
import SidebarVendor from '@/views/Admin/Company/SidebarAdd.vue'
import {mapState} from 'vuex'
export default {
  name: 'Add_view',
  data () {
    return {
      company_name: '',
      address: '',
      zip_code: '',
      capital: '',
      business_content: '',
      number_employees: '',
      representative_name: '',
      representative_phone: '',
      representative_email: '',
      homepage: '',
      paginations: {
        page_index: 1,
        sortBy: 'created_at',
        sortOrder: 'desc',
        searchQuery: '',
        typingTimer: null,
        isTyping: false,
        displayParentCompanyOnly: 1
      },
      parent_company: 0,
      company_uuid: null
    }
  },
  components: {
    Header,
    Breadcrumb,
    SidebarVendor
  },
  methods: {
    goback () {
      this.$router.push('/admin/companies')
    },
    addCompany (e) {
      e.preventDefault()
      const formData = new FormData()
      if (this.editLogoCompany.logo) {
        formData.append('logo', this.editLogoCompany.logo)
      }
      formData.append('company_name', this.company_name)
      formData.append('representative_name', this.representative_name)
      formData.append('representative_phone', this.representative_phone)
      formData.append('representative_email', this.representative_email)
      formData.append('address', this.address)
      if (this.number_employees) {
        formData.append('number_employees', this.number_employees)
      }
      if (this.capital) {
        formData.append('capital', this.capital)
      }
      if (this.zip_code) {
        formData.append('zip_code', this.zip_code)
      }
      if (this.homepage) {
        formData.append('homepage', this.homepage)
      }
      if (this.business_content) {
        formData.append('business_content', this.business_content)
      }

      if (this.parent_company) {
        formData.append('parent_company', this.parent_company)
      } else if (!this.parent_company && this.company_uuid) {
        formData.append('parent_company', this.parent_company)
        formData.append('company_uuid', this.company_uuid)
      }

      this.$store.dispatch('adminCompany/addCompany', {formData})
    }
  },
  mounted () {
    this.$store.dispatch('adminCompany/getCompany', this.paginations)
  },
  computed: {
    ...mapState({
      editLogoCompany: state => state.adminCompany.editLogoCompany,
      companies: state => state.adminCompany.companies
    })
  }
}
</script>
<style scoped lang="scss">
  @import '@/assets/stylesheet/admin/vendor.scss';
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Add.vue